import { useMutation, useQueryClient } from "@tanstack/react-query";
import { startCourse } from "../../../core/queries/course";

export function useRegisterCourses() {
    const queryClient = useQueryClient();

    const {
        data,
        isError,
        error,
        isSuccess,
        isPending,
        mutate
    } = useMutation({
            mutationKey: ['course-register'],
            mutationFn: (slug: string) => startCourse(slug),
            retry: false,
            onSuccess: () => {
                queryClient.removeQueries({ queryKey: ['myCourses'] });
            }
        });

    return {
        data,
        isError,
        isLoading: isPending,
        error,
        isSuccess,
        mutate,
    };
}
